export const pathRoutes = {
  // pages
  Home: { path: "/" },
  About: { path: "/about" },
  Contact: { path: "/contact" },
};
